import tokenData from '../../design-tokens/base-tokens.json';
export const MuiMenu = {
    styleOverrides: {
        paper: {
            minWidth: '200px'
        }
    }
};
export const MuiMenuItem = {
    styleOverrides: {
        root: ({ theme }) => ({
            color: tokenData.tokens.palette.text.text300,
            whiteSpace: 'break-spaces',
            padding: theme.spacing(2, 4),
            '&.Mui-focusVisible': {
                backgroundColor: tokenData.tokens.palette.grey.grey100,
                outline: '2px solid #000000',
                outlineOffset: -2
            },
            '&:hover': {
                backgroundColor: tokenData.tokens.palette.grey.grey100
            },
            '&. MuiListItemText-primary': {
                fontWeight: '700'
            },
            '&.Mui-selected': {
                fontWeight: '700',
                backgroundColor: 'unset',
                '& .MuiTypography-root': {
                    fontWeight: '700'
                },
                '&. MuiListItemText-root, .MuiTypography-root': {
                    fontWeight: '700',
                    backgroundColor: tokenData.tokens.palette.grey.grey100
                },
                '&:hover, &:focus': {
                    backgroundColor: tokenData.tokens.palette.grey.grey100
                }
            },
            '& .MuiCheckbox-root': {
                alignSelf: 'flex-start'
            },
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled,
                pointerEvents: 'unset',
                cursor: 'not-allowed',
                opacity: 1
            },
            '& .MuiListItemIcon-root': {
                color: tokenData.tokens.palette.text.text100,
                minWidth: 28
            }
        })
    }
};
